<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Contrato Digital
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-8">
              <input-field
                label="Chave do Contrato"
                v-model="digitalContractForm.get('providerTemplateId').value"
                :errors="digitalContractForm.get('providerTemplateId').errors"
              />
            </div>
            <div class="col-md-4">
              <select-field
                label="Status"
                v-model="digitalContractForm.get('status').value"
                :errors="digitalContractForm.get('status').errors"
                :disabled="true"
                :options="status"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="createDigitalContract()">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputField, SelectField } from 'components/form';
import { FormGroup } from 'utils/form';
import InstitutionDigitalContractsService from 'services/InstitutionDigitalContractsService';

export default {
  components: {
    InputField,
    SelectField,
  },
  data() {
    return {
      status: [
        { value: true, label: 'Habilitado' },
        { value: false, label: 'Desabilitado' },
      ],
      digitalContractForm: new FormGroup({
        qbId: { required: true },
        providerTemplateId: { required: true },
        status: { value: true, required: true },
      }),
    };
  },
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  mounted() {
    this.digitalContractForm.addValues({ qbId: this.institution.qb_university_id });
  },
  methods: {
    createDigitalContract() {
      if (this.digitalContractForm.validateForm()) {
        this.$loader.show();
        InstitutionDigitalContractsService.create(this.digitalContractForm.getRawValue())
          .then(({ data }) => {
            this.$alert.notifySuccess('Contrato Digital criado com sucesso.');
            this.$emit('digital-contract-created', data);
          })
          .catch(() => {
            this.$alert.notifyAlert('Erro ao criar Contrato Digital');
          })
          .finally(() => {
            this.$loader.hide();
          });
      }
    },
  },
};
</script>
